import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { uiTranslations } from "@/ui-kit";
import translation from "./translations/en.json";

export const resources = {
  en: {
    // The kit owns its `ui.*` strings; merge them so the injected `t` resolves them.
    translation: { ...translation, ...uiTranslations },
  },
} as const;

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  keySeparator: ".",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
